import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import MerchandiseMegaMenuContainer from '../MerchandiseMegaMenu/components/MerchandiseMegaMenuContainer'
import MerchandiseMegaMenuPanel from '../MerchandiseMegaMenu/components/MerchandiseMegaMenuPanel'
import { TRAVEL_ESSENTIALS_ITEMS } from 'constants/merchandise'

const Container = styled(MerchandiseMegaMenuPanel)`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  padding-block: ${rem(32)};
  padding-inline: ${rem(24)};
`

const StyledClickableListItem = styled(ClickableListItem)`
  && {
    padding: ${rem(12)};
  }
`

interface Props {
  onClose: () => void
}

function MerchandiseTravelEssentialsMegaMenu(props: Props) {
  const { onClose } = props

  return <MerchandiseMegaMenuContainer width={370} alignWithButton>
    <Container>
      {TRAVEL_ESSENTIALS_ITEMS.map(item => (
        <StyledClickableListItem
          key={item.id}
          to={item.url}
          onClick={onClose}
          title={item.name}
          titleColour="neutral-one"
          size="medium"
        />
      ))}
    </Container>
  </MerchandiseMegaMenuContainer>
}

export default MerchandiseTravelEssentialsMegaMenu
